<section class="w-[600px] h-[800px] bg-white overflow-y-auto mobile-preview">
    @if (courseData$ | async; as courseData) {
    <div class="aspect-[16/6] bg-zinc-200">
        <img class="w-full h-full object-fill" [src]="courseData.thumbnail" [alt]="courseData.course_name">
    </div>

    <div class="px-5 -mt-8 relative z-10">
        <div class="bg-white border rounded-lg p-3 shadow-sm">
            <div class="flex items-end justify-between gap-3">
                <div class="flex items-end gap-3">
                    <img class="w-12 h-12 object-cover rounded-md bg-white border"
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8oghbsuzggpkknQSSU-Ch_xep_9v3m6EeBQ&s"
                        alt="Instructor" />
                    <div class="mb-1">
                        <div class="text-zinc-400 text-xs flex gap-0.5">
                            <i class="ri-star-line"></i>
                            <i class="ri-star-line"></i>
                            <i class="ri-star-line"></i>
                            <i class="ri-star-line"></i>
                            <i class="ri-star-line"></i>
                        </div>
                    </div>
                </div>
                <p class="text-xs text-cyan-700 font-semibold">({{reviewsList.length}})</p>
            </div>

            <h3 class="text-2xl text-slate-700 font-medium mt-2 capitalize line-clamp-2">{{courseData.course_name}}</h3>
            <p class="mt-1 text-sm text-zinc-500 line-clamp-2">{{courseData.description}}</p>

            <div class="mt-2 flex items-start gap-2">
                <span class="text-xs text-zinc-600 font-medium mt-0.5">Useful for :</span>
                <ul class="text-xs flex gap-2 flex-wrap">
                    @for (item of getUsefulForList(courseData.usefull_for_hint, courseDetails?.usefull_for); track $index) {
                    <li class="text-zinc-700 px-1.5 py-0.5">{{item}}</li>
                    }
                </ul>
            </div>
        </div>
    </div>

    <div class="mt-3 border-b px-4 flex">
        @for (tab of tabs; track $index) {
        <button type="button" class="flex-1 py-2 text-sm capitalize border-b-2 transition-colors"
            [ngClass]="currentTab === tab ? 'border-cyan-500 text-zinc-700 font-medium' : 'border-transparent text-zinc-500'"
            (click)="currentTab = tab">
            {{tab}}
        </button>
        }
    </div>

    <div class="px-4 py-3 h-[410px] overflow-y-auto">
        @if (currentTab === 'structure') {
        <ul class="space-y-2">
            @if (structureList.length === 0) {
            <li class="text-sm text-zinc-400">No structure data</li>
            } @else {
            @for (item of structureList; track $index) {
            <li class="text-sm text-zinc-700 flex items-center gap-2"
                [style.padding-left.px]="item.level * 16">
                <i class="ri-arrow-right-s-line text-cyan-500"></i>
                <span>{{item.label}}</span>
            </li>
            }
            }
        </ul>
        }

        @if (currentTab === 'details') {
        <div class="space-y-4">
            @if (courseDetails?.benefits) {
            <div>
                <p class="text-xs font-semibold text-zinc-500 uppercase">Benefits</p>
                <ul class="mt-1 space-y-1">
                    @for (item of parseTextList(courseDetails?.benefits); track $index) {
                    <li class="text-sm text-zinc-700 flex gap-2"><i class="ri-check-line text-cyan-500"></i><span>{{item}}</span></li>
                    }
                </ul>
            </div>
            }

            @if (courseDetails?.features) {
            <div>
                <p class="text-xs font-semibold text-zinc-500 uppercase">Features</p>
                <p class="text-sm text-zinc-700 mt-1 whitespace-pre-line">{{courseDetails?.features}}</p>
            </div>
            }

            @if (courseDetails?.how_to_use) {
            <div>
                <p class="text-xs font-semibold text-zinc-500 uppercase">How to use</p>
                <p class="text-sm text-zinc-700 mt-1 whitespace-pre-line">{{courseDetails?.how_to_use}}</p>
            </div>
            }

            @if (courseDetails?.others) {
            <div>
                <p class="text-xs font-semibold text-zinc-500 uppercase">Other details</p>
                <p class="text-sm text-zinc-700 mt-1 whitespace-pre-line">{{courseDetails?.others}}</p>
            </div>
            }

            @if (!courseDetails?.benefits && !courseDetails?.features && !courseDetails?.how_to_use && !courseDetails?.others) {
            <p class="text-sm text-zinc-400">No details available</p>
            }
        </div>
        }

        @if (currentTab === 'review') {
        <div class="space-y-3">
            @if (reviewsList.length === 0) {
            <p class="text-sm text-zinc-400">No reviews yet</p>
            } @else {
            @for (review of reviewsList; track $index) {
            <div class="border rounded-md p-3">
                <div class="flex items-center justify-between gap-2">
                    <p class="text-sm font-semibold text-zinc-700">{{review?.user?.name || 'User'}}</p>
                    <div class="flex items-center gap-0.5 text-amber-500 text-xs">
                        @for (star of ratingStars; track $index) {
                        <i [ngClass]="getRoundedRating(review?.rating) >= star ? 'ri-star-fill' : 'ri-star-line'"></i>
                        }
                    </div>
                </div>
                <p class="text-xs text-zinc-400 mt-0.5">{{review?.created_at | date}}</p>
                <p class="text-sm text-zinc-600 mt-2">{{review?.review}}</p>
            </div>
            }
            }
        </div>
        }
    </div>
    } @else {
    <div class="p-5 space-y-3">
        <div class="h-36 skeleton rounded-lg"></div>
        <div class="h-5 w-2/3 skeleton rounded"></div>
        <div class="h-4 w-full skeleton rounded"></div>
        <div class="h-4 w-5/6 skeleton rounded"></div>
        <div class="h-4 w-4/6 skeleton rounded"></div>
    </div>
    }
</section>
